module.exports = __webpack_public_path__ + "assets/464bb15628ef2541f15771477acdb3bb.mp3";